import { UserRole } from '@/services/ws-permissions/src/main/resources/rest-api/types.ts';
import { PermissionType } from '@/js/libs/generated/permissions/types.ts';
import { CombinedRole } from './types.js';
const Roles = {
    ...UserRole,
    ...PermissionType,
    ...CombinedRole,
};
export { Roles };
